import React from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from "react-redux";
import reactStringReplace from 'react-string-replace';

import {CardContainer, Button} from 'components/common/uiKit';

import {stringFormat} from 'services/converts/strings';

class Android extends React.Component {

    downloadOnClick = () => {
        window.location = "https://melinarahmani.com/MeAcademy.apk";
    };

    useWebOnClick = () => {
        const {history} = this.props;
        history.replace({
            pathname: '/app/home'
        });
    };


    render() {
        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.OS.Android;

        const AppName = props => <span className='color-primary font-weight-bold'> {pageTranslates.AppName} </span>;

        return (
            <CardContainer>
                <p>
                    {reactStringReplace(pageTranslates.Description, '{{0}}', () => <AppName/>)}
                </p>
                <Button full type='primary' onClick={this.downloadOnClick} shadowType='sm'>
                    <span className='font-weight-bold'>
                        {stringFormat(pageTranslates.Download, [pageTranslates.AppName])}
                    </span>
                </Button>
                <Button full type='secondary' onClick={this.useWebOnClick} shadowType='sm'>
                    <span className='font-weight-bold'>
                        {pageTranslates.Web}
                    </span>
                </Button>
            </CardContainer>
        );
    }
}

const mapStateToProps = state => {
    const {locale} = state;
    return {locale};
};

export default connect(mapStateToProps, null)(withRouter(Android));

